export default {
    bruto: 'Bruto',
    formatado: 'Formatado',
    copiar: 'Copiar',
    copiado_sucesso: 'Conteúdo copiado com sucesso!'
}